import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { logout, headerActions, dashboardActions, redirectToRoute } from 'actions';
import { HEADER } from '_constants';
import { bindActionCreators } from 'redux';

import UserProfileUI from './UserProfileUI';
import * as memberSelectors from '../../reducers/member.reducer';

const headerSettings =
{
  type: HEADER.UPDATE_HEADER,
  showHeader: true,
  hasBackButton: true,
  hasNotificationIcon: true,
  backButtonIcon: 'back',
  headerClassName: 'user-profile'
};

const UserProfile = ({ ...props }) => {
  const logout = () => {
    props.logout();
    props.redirectTo("/azureb2clogout");
  };

  useEffect(() => {
    props.getMember(props.userprofile.memberKey).then(() => {
      props.setHeader({
        ...headerSettings,
        headerTitle: <React.Fragment>
          <div className='member-full-name'>
            {props.userprofile.memberFullName}
          </div>
          <div className='office-name'>
            {props.userprofile.officeName}
          </div>
        </React.Fragment>
      });
    });
  }, []);

  return (
    <React.Fragment>
      <section className='page-content user-profile-page'>
        <div className='page-content-body user-profile-body profile-content'>
          <UserProfileUI
            outOfOffice={props.outOfOffice}
            userprofile={props.userprofile}
            logout={logout}
            redirectTo={props.redirectTo}
          />
        </div>
        <div className='profile-content-footer'>
          <div><span className=''>If your profile information requires updating, please email </span><a href='mailto:xomeproagentsupport@xome.com'>xomeproagentsupport@xome.com</a><span> for assistance</span></div>
          <div className='log-out-container'><button className='log-out' onClick={logout}>Log Out</button></div>
        </div>
      </section>
    </React.Fragment>
  );
};

UserProfile.propTypes = {
  userprofile: PropTypes.object.isRequired,
  setHeader: PropTypes.func.isRequired,
  getMember: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  redirectTo: PropTypes.func.isRequired,
  outOfOffice: PropTypes.shape({
    startDateTime: PropTypes.string,
    endDateTime: PropTypes.string
  })
};

const mapStateToProps = (state) => {
  const { userprofile, member } = state;
  return {
    userprofile,
    outOfOffice: _.get(memberSelectors.memberData(member), 'outOfOffice', {})
  };
};

const mapDispatchToProps = (dispatch) => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  getMember: bindActionCreators(dashboardActions.getMember, dispatch),
  logout: bindActionCreators(logout, dispatch),
  redirectTo: bindActionCreators(redirectToRoute, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserProfile));
